import { t } from '../i18n';
import type { Controls } from '../scene/controls';

const AUTO_DISMISS_MS = 8000;

/** One-shot onboarding hint: shown after intro, dismissed on first drag or timeout. */
export function showCoachMark(controls: Controls): void {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const el = document.createElement('div');
  el.id = 'coach-hint';
  el.textContent = t('coachHint');
  document.body.appendChild(el);

  let dismissed = false;
  let timer: ReturnType<typeof setTimeout>;

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    clearTimeout(timer);
    controls.setOnFirstDrag(null);

    if (reduced) {
      el.remove();
      return;
    }
    el.classList.remove('visible');
    const remove = () => el.remove();
    el.addEventListener('transitionend', remove, { once: true });
    setTimeout(remove, 400);
  };

  controls.setOnFirstDrag(dismiss);
  timer = setTimeout(dismiss, AUTO_DISMISS_MS);

  if (reduced) {
    el.classList.add('visible');
  } else {
    requestAnimationFrame(() => el.classList.add('visible'));
  }
}
